import React, { useEffect, useState } from 'react'
import { useHistory } from 'react-router-dom'
import { Popup } from '../../../../library/popup'
import { TransparentButton } from '../../../../library/button'
import { changeCampaignsModal } from '../../../../../redux/actions/campaigns'
import Interweave from 'interweave'
import { useDispatch, useSelector } from 'react-redux'

import './style.scss'

const Index = () => {
    const dispatch = useDispatch()

    const history = useHistory()

    const modalState = useSelector(state => state.campaigns.showModals.viewEmailModal)

    const activeEmail = useSelector(state => state.campaigns.emailDisplay)

    const [emailDisplay, setEmailDisplay] = useState({
        content: null
    })

    const handleClose = () => {
        dispatch(changeCampaignsModal({viewEmailModal: false}))
    }

    useEffect(() => {
        if(Object.keys(activeEmail).length > 0){
            setEmailDisplay(activeEmail)
        }
    }, [activeEmail])


    return(
        <Popup 
			onClose={handleClose}
			show={modalState} 
			title="E-post utsendt"
			description="Nedenfor ser du hvordan e-posten du sendte så ut."
			buttons={[
				<TransparentButton title="Lukk" type="button" data-dismiss="modal" onClick={() => handleClose()} />
			]}
		>
            <div className="email-sent-content-container">
                <Interweave content={emailDisplay.content} className="view-email-container"/>
            </div>
        </Popup>
    )
}

export default Index
